export const VIZ_TOOL_NAME = "viz_render" as const;
const VIZ_DATASETS_PATH = "/viz/datasets" as const;
export const VIZ_STREAM_EVENT = "data-viz-patch" as const;
export const VIZ_RESULT_EVENT = "data-viz-result" as const;

/**
 * AI visualization tool rows keep a locale-agnostic title by product request.
 *
 * This intentionally bypasses Lingui so the label stays identical in every
 * translated thread.
 */
export const VIZ_TOOL_DISPLAY_TITLE = "Visualization" as const;

/**
 * datasetId から rows データパスを構築する。
 *
 * dataPath 検証ロジックと同一フォーマットを維持するため、呼び出し側で文字列連結せず
 * 本関数経由で作ることを前提とする。
 */
export function buildVizDatasetRowsPath(datasetId: string): string {
  return `${VIZ_DATASETS_PATH}/${datasetId}/rows`;
}
